export default {
  name: 'cartesianWidget1',
  spec: {
    datasources: {
      key1: {
        type: 'uql',
        options: {
          since: '/${ globals.timerange.since }',
          until: '/${ globals.timerange.until }',
          fetchItems: {
            'Balance Credits': "metrics(cloud:system.cpu.balance.credits, 'aws-cloudwatch')",
            'Used Credits': "metrics(cloud:system.cpu.used.credits, 'aws-cloudwatch')",
          },
          fetch: "${ 'FETCH ' & $join($each(fetchItems, function($v, $k) { '`' & $k & '`' & ':' & $v }), ', ') }",
          from: "/${ 'FROM entities(aws:ec2)' }",
          filters: [],
          filterStr:
            "${ $count([$filter(filters, $boolean)]) > 0 ? '[' & $join([$filter(filters, $boolean)], ' && ') & ']' : '' }",
          limits: ['metrics.granularityDuration(PT5M)'],
          limitStr:
            "${ $count([$filter(limits, $boolean)]) > 0 ? 'LIMITS ' & $join([$filter(limits, $boolean)], ' ') : '' }",
          queryStr: "${ $join([from, filterStr, fetch, limitStr], ' ') }",
        },
      },
    },
    view: [
      [
        'dashify:CardWithTitle',
        { title: 'CPU Credits' },
        [
          [
            'dashify:Cartesian',
            {
              highchartsConfig: {
                chart: {
                  type: 'line',
                },
                legend: { enabled: true },
                tooltip: {
                  shared: true,
                },
                xAxis: {
                  min: '/${ $parseDateTime(data.key1.metadata.since) }',
                  max: '/${ $parseDateTime(data.key1.metadata.until) }',
                },
                series:
                  "/${ $count($keys(data.key1.data)) > 0 ? data.key1.data@$d.$each($d,function ($v, $k){ {'name': $k, 'data': $count($v) > 0 ? $v.[timestamp, value][] : []}[] }) : [] }",
              },
            },
          ],
        ],
      ],
    ],
  },
};
